var Marionette = require('backbone.marionette');

var Router = Marionette.AppRouter.extend({
    appRoutes: {
        '': 'showRoot',
        'organizations': 'organizationsList',
        'organization/:entry': 'organizationEntry',
        'organization/:entry/patients': 'organizationEntryPatients',
        'documents': 'documentsList',
        'document/:entry': 'documentEntry',
        'document-history/:entry': 'documentHistoryEntry',
        'history/:entry': 'historyEntries',
        'upload': 'documentUploadShow',
        'upload-signed': 'uploadSignedDocumentShow',
        'login': 'login',
        'signup': 'signup',
        'settings': 'settingsList',
        'persons': 'personsList',
        'person/:entry': 'personEntry',
        'relations': 'relationsList',
        'relationtypes': 'relationtypesList',
        'relationtype/:entry': 'relationtypeEntry',
        'roles': 'rolesList',
        'changepassword/:entry': 'changePasswordEntry',
        'doctypes': 'doctypesList',
        'help': 'helpSectionsList',
        'help-physician': 'helpPhysician',
        'help-office-admin': 'helpOfficeAdmin',
        'help-corporate-admin': 'helpCorporateAdmin',
        'help-feedback': 'helpFeedback',
        'patients': 'patientsList',
        'statistics': 'statistics',
        'login/by-instant-token/:token':'instantToken',
        'import-persons': 'importPersons',
        'merge-persons': 'mergePersons',
        'merge-persons/:mergeTo/:mergeFrom': 'mergePersons',
        'cmform': 'referralForm',
        'village-podiatry-form': 'villagePodiatryForm',
        'ff-form': 'faceToFaceForm',
        'ff-form/:entry': 'faceToFaceForm',
        'ff-forms': 'faceToFaceFormsList'
    },

    initialize: function(){
        this.controller = this.getOption('controller');
    }

});

module.exports = Router;


//////////////////
// WEBPACK FOOTER
// ./app/router.js
// module id = 184
// module chunks = 0